import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NavHelperService } from '../../../../services/nav/nav-helper.service';
import { SelectOperationPage } from '../../../operations/select-operation/select-operation';
import { OperationType, PageArgs } from '../../../../models/projects/operation.models';
import { CommentEditPage } from '../../../comments/comment-edit/comment-edit';
import { LockedDayService } from '../../../../services/locked-day/locked-day.service';
import { SidebarPermissions } from '../../../../models/permissions/permission.models';
import { PermissionsService } from '../../../../services/permissions/permissions.service';
import { AppConfig } from '../../../../app/app.config';
import { SupportContextKey } from '../../../../models/support/support.models';

@IonicPage()
@Component({
  selector: 'page-nav-daily-log-submenu',
  templateUrl: 'nav-daily-log-submenu.html',
})
export class NavDailyLogSubmenuPage {
  @ViewChild('content') nav: NavController;

  config = AppConfig.settings;

  sidebarCollapsed: boolean;
  permissions: SidebarPermissions = new SidebarPermissions();
  canEnterData: boolean;
  dailyLogStale: boolean = false;
  setupConfigured: boolean;

  dailyLogPages = [
    {
      title: 'Add Contractual Operation',
      component: SelectOperationPage,
      type: OperationType.Contractual,
      supportContextKey: SupportContextKey.AddToDailyLog,
      active: this.permissions.canClickAddToDailyLog
    },
    {
      title: 'Add Concurrent Operation',
      component: SelectOperationPage,
      type: OperationType.Concurrent,
      supportContextKey: SupportContextKey.AddToDailyLog,
      active: this.permissions.canClickAddToDailyLog
    },
    {
      title: 'Add Contractual Delay',
      component: SelectOperationPage,
      type: OperationType.Delay,
      supportContextKey: SupportContextKey.AddToDailyLog,
      active: this.permissions.canClickAddToDailyLog
    },
    {
      title: 'Add Concurrent Delay',
      component: SelectOperationPage,
      type: OperationType.Interruption,
      supportContextKey: SupportContextKey.AddToDailyLog,
      active: this.permissions.canClickAddToDailyLog
    },
    {
      title: 'Add Comment',
      component: CommentEditPage,
      supportContextKey: SupportContextKey.AddToDailyLog,
      active: this.permissions.canClickAddToDailyLog
    },
  ];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public navHelperService: NavHelperService,
              public lockedDayService: LockedDayService,
              public permissionService: PermissionsService,
  ) {
    this.navHelperService.currentSidebarCollapsed.subscribe(sidebarCollapsed => {
      this.sidebarCollapsed = sidebarCollapsed;
    });

    this.navHelperService.canEnterData.subscribe(canEnterData => {
      this.canEnterData = canEnterData;
    });

    this.navHelperService.dailyLogStale.subscribe(dailyLogStale => {
      this.dailyLogStale = dailyLogStale;
    });

    this.navHelperService.currentSetupConfigured.subscribe(setupConfigured => {
      this.setupConfigured = setupConfigured;
    });
  }

  ionViewDidLoad() {
  }

  ionViewDidEnter() {
    this.permissionService
      .sidebarPermissions()
      .then(res => {
        this.permissions = res;
        this.dailyLogPages = [
          {
            title: 'Add Contractual Operation',
            component: SelectOperationPage,
            type: OperationType.Contractual,
            supportContextKey: SupportContextKey.AddToDailyLog,
            active: this.permissions.canClickAddToDailyLog
          },
          {
            title: 'Add Concurrent Operation',
            component: SelectOperationPage,
            type: OperationType.Concurrent,
            supportContextKey: SupportContextKey.AddToDailyLog,
            active: this.permissions.canClickDailyLog
          },
          {
            title: 'Add Contractual Delay',
            component: SelectOperationPage,
            type: OperationType.Delay,
            supportContextKey: SupportContextKey.AddToDailyLog,
            active: this.permissions.canClickAddToDailyLog
          },
          {
            title: 'Add Concurrent Delay',
            component: SelectOperationPage,
            type: OperationType.Interruption,
            supportContextKey: SupportContextKey.AddToDailyLog,
            active: this.permissions.canClickAddToDailyLog
          },
          {
            title: 'Add Comment',
            component: CommentEditPage,
            supportContextKey: SupportContextKey.AddToDailyLog,
            active: this.permissions.canClickAddToDailyLog
          }
        ];
      });
  }

  selectPage(page: any, type?: OperationType, title?: string, supportContextKey?: SupportContextKey) {
    if (this.dailyLogStale) {
      return;
    }

    if (this.navHelperService.warned || this.navHelperService.unsavedChanges === false) {
      this.navHelperService.unsavedChanges = false;
      const navPage = new PageArgs();
      navPage.page = page;
      navPage.params = {type: type};
      navPage.supportContextKey = supportContextKey;
      navPage.supportContextLabel = title;
      this.navHelperService.updateNavPage(navPage);
      return;
    }

    this.navHelperService.warned = true;
    this.navHelperService.showWarning = true;

    return;
  }

  collapseSidebar() {
    this.navHelperService.toggleSidebarCollapse();
  }
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-menus/nav-daily-log-submenu/nav-daily-log-submenu.ts